import { useState } from "react";

import { FALLBACK } from "@/data/images";

export default function SafeImage({
  src,
  alt,
  className = "",
  loading = "lazy",
  fetchPriority,
  sizes,
}) {
  const [failed, setFailed] = useState(false);

  return (
    <img
      src={failed ? FALLBACK : src}
      alt={alt}
      className={className}
      loading={loading}
      fetchPriority={fetchPriority}
      sizes={sizes}
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
